































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import format from '@/filter/dateFormat';
import { MAIL } from '../store';
import DatePicker from '@/components/form/DatePicker.vue';
import { MailCompensation } from '../types';
import { ApiResponse } from '@/components/types';

const Compensation = namespace('compensation');

@Component({
  components: {
    DatePicker
  }
})
export default class MailCompensationDialog extends Vue {
  @Prop({ type: String }) compensationId!: string | null;

  @Compensation.Action(MAIL) mailCompensation!: (params: MailCompensation) => Promise<ApiResponse>;

  dialog: boolean = false;
  error: any = null;

  compensation: MailCompensation = {
    compensation_id: '',
    mailed: ''
  };

  @Watch('dialog')
  watchDialogClosed(value: boolean) {
    if (value) return;

    this.compensation.compensation_id = '';
    this.compensation.mailed = '';
    this.error = null;
    // @ts-ignore
    this.$refs.form.reset();
    this.$emit('update:compensationId', null);
  }

  @Watch('compensationId')
  watchCompensationClosed(compensationId: string | null) {
    if (!compensationId) return;

    this.compensation.compensation_id = compensationId;
    this.compensation.mailed = format(new Date(), 'yyyy-MM-dd');

    setTimeout(() => {
      this.dialog = true;
    }, 200);
  }

  save() {
    this.error = null;

    return this.mailCompensation(this.compensation);
  }
}
